/** A to-do the office added: what it asks, and that the office is the one to mark it done. */
import { StepHeader, Section, type StepProps } from './stepParts';

export default function TodoStep({ step }: StepProps) {
  const details = step.todo?.details;

  return (
    <div className="space-y-6">
      <StepHeader step={step} />
      <Section>
        {details ? <p className="whitespace-pre-line break-words">{details}</p> : null}
        <p className="text-muted-foreground">The office will mark this done.</p>
      </Section>
    </div>
  );
}
